<template>
  <div class="full-screen-background">
    <v-container class="pa-4 fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4" class="text-center">
          <v-card>
            <v-card-text>
              <div v-if="loading">{{ t('confirmEmail.loading') }}</div>
              <div v-else>
                <v-icon size="64" v-if="success" color="green">mdi-check-circle</v-icon>
                <v-icon size="64" v-else color="red">mdi-alert-circle</v-icon>
                <h3 class="mt-4">{{ message }}</h3>
              </div>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="#5c3e62" dark @click="goHome">{{ t('confirmEmail.goHome') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { confirmEmailChange } from '@/services/api'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const loading = ref(true)
const success = ref(false)
const message = ref('')

onMounted(async () => {
  const token = route.query.token
  if (!token) {
    message.value = t('confirmEmail.error.invalidToken')
    loading.value = false
    return
  }
  try {
    await confirmEmailChange(token)
    message.value = t('confirmEmail.success')
    success.value = true
  } catch (err) {
    message.value = err.message
  } finally {
    loading.value = false
  }
})

function goHome() {
  router.push({ name: 'Home' })
}
</script>

<style scoped>
.full-screen-background {
  background-image: url('@/assets/background/fundotrocasenha.png');
  background-size: cover;
  background-position: center;
  position: relative;
  min-height: 100vh;
}
.full-screen-background::before {
  content: '';
  position: absolute;
  inset: 0;
  background-color: rgba(0,0,0,0.3);
}
</style>
